import React, { useEffect, useRef, Component } from 'react';
import { companyLogos } from '../utils/constants';
const LogoCarousel = ({
  language = 'en'
}) => {
  const carouselRef = useRef(null);
  const sectionRef = useRef(null);
  // Animation for section entrance
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const elements = entry.target.querySelectorAll('.fade-in');
          elements.forEach((el, index) => {
            setTimeout(() => {
              el.classList.add('active');
            }, index * 100);
          });
        }
      });
    }, {
      threshold: 0.1
    });
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);
  // Create duplicate logos for continuous scrolling
  const duplicatedLogos = [...companyLogos, ...companyLogos];
  const translations = {
    en: {
      experience: 'Experience at',
      leadingCompanies: 'Leading Companies',
      connectOnLinkedin: 'Connect on LinkedIn'
    },
    vi: {
      experience: 'Kinh Nghiệm tại',
      leadingCompanies: 'Các Công Ty Hàng Đầu',
      connectOnLinkedin: 'Kết nối trên LinkedIn'
    }
  };
  const t = translations[language];
  return <section id="logos" ref={sectionRef} className="w-full py-16 bg-secondary overflow-hidden" data-id="element-870">
      <div className="container mx-auto px-4" data-id="element-871">
        <h2 className="text-2xl md:text-3xl font-display font-bold text-center mb-16 fade-in" data-id="element-872">
          {t.experience}{' '}
          <span className="gradient-text" data-id="element-873">{t.leadingCompanies}</span>
        </h2>
        {/* Mobile Carousel (Continuous Scroll) */}
        <div className="md:hidden overflow-hidden" data-id="element-874">
          <div className="flex animate-[scroll_20s_linear_infinite] hover:pause-animation" style={{
          width: `${companyLogos.length * 200}px`
        }} ref={carouselRef} data-id="element-875">
            {duplicatedLogos.map((company, index) => <div key={`mobile-${company.name}-${index}`} className="w-[160px] mx-4 flex-shrink-0" data-id="element-876">
                <LogoItem company={company} language={language} data-id="element-877" />
              </div>)}
          </div>
        </div>
        {/* Tablet/Desktop Carousel (Continuous Scroll) */}
        <div className="hidden md:block overflow-hidden" data-id="element-878">
          <div className="flex animate-[scroll_30s_linear_infinite] hover:pause-animation" style={{
          width: `${companyLogos.length * 250}px`
        }} ref={carouselRef} data-id="element-879">
            {duplicatedLogos.map((company, index) => <div key={`desktop-${company.name}-${index}`} className="w-[200px] mx-6 flex-shrink-0" data-id="element-880">
                <LogoItem company={company} language={language} data-id="element-881" />
              </div>)}
          </div>
        </div>
        <style jsx data-id="element-882">{`
          @keyframes scroll {
            0% {
              transform: translateX(0);
            }
            100% {
              transform: translateX(-50%);
            }
          }
          .hover\\:pause-animation:hover {
            animation-play-state: paused;
          }
        `}</style>
      </div>
    </section>;
};
// Logo Item Component
const LogoItem = ({
  company,
  language = 'en'
}) => {
  const translations = {
    en: {
      connectOnLinkedin: 'Connect on LinkedIn'
    },
    vi: {
      connectOnLinkedin: 'Kết nối trên LinkedIn'
    }
  };
  const t = translations[language];
  return <div className="relative group" data-id="element-883">
      <div className="w-full h-20 flex items-center justify-center bg-white rounded-lg p-4 transition-all duration-300 transform group-hover:scale-110 group-hover:shadow-lg" data-id="element-884">
        <img src={company.logo} alt={company.name} className="max-h-full max-w-full object-contain" data-id="element-885" />
      </div>
      {/* Tooltip - Positioned below the logo */}
      <div className="invisible group-hover:visible absolute top-24 left-1/2 transform -translate-x-1/2 bg-secondary text-primary p-4 rounded-lg shadow-xl text-sm transition-all duration-300 w-64 z-50 border-2 border-accent-cyan/30" data-id="element-886">
        <p className="font-semibold text-center text-accent-cyan text-base mb-1" data-id="element-887">
          {company.name}
        </p>
        <p className="font-medium text-center mb-1 text-white" data-id="element-888">
          {language === 'en' ? company.role : company.roleVi}
        </p>
        <p className="text-muted text-center" data-id="element-889">
          {language === 'en' ? company.year : company.yearVi || company.year}
        </p>
        <div className="absolute top-[-10px] left-1/2 transform -translate-x-1/2 w-5 h-5 bg-secondary border-t-2 border-l-2 border-accent-cyan/30 rotate-45" data-id="element-890"></div>
      </div>
    </div>;
};
export default LogoCarousel;